/**
 * Luxury Collection section (luxury-collect.liquid)
 * Supports multiple instances per page; initializes each .ece section once.
 */
(function () {
  'use strict';

  function initLuxuryCollection(sectionId) {
    const section = document.getElementById('ece-' + sectionId);
    if (!section || section.dataset.luxuryCollectionInit === 'true') return;
    section.dataset.luxuryCollectionInit = 'true';

    const sid = sectionId;
    const rail = document.getElementById('ece-rail-' + sid);
    const dWrap = document.getElementById('ece-dots-' + sid);
    const cvs = document.getElementById('ece-canvas-' + sid);

    if (cvs) {
      const ctx = cvs.getContext('2d');
      let W, H;
      let isVisible = true;

      const fit = () => {
        W = cvs.width = cvs.offsetWidth;
        H = cvs.height = cvs.offsetHeight;
      };
      fit();
      new ResizeObserver(fit).observe(cvs.parentElement);

      const visibilityObserver = new IntersectionObserver(
        (entries) => {
          isVisible = entries[0].isIntersecting;
        },
        { threshold: 0 }
      );
      visibilityObserver.observe(cvs.parentElement);

      const pts = Array.from({ length: 45 }, () => ({
        x: Math.random() * 2000,
        y: Math.random() * 1200,
        r: Math.random() * 1.1 + 0.2,
        a: Math.random() * 0.38 + 0.07,
        dy: -(Math.random() * 0.14 + 0.035),
        dx: (Math.random() - 0.5) * 0.035,
        ph: Math.random() * Math.PI * 2
      }));

      (function tick() {
        if (!isVisible) {
          requestAnimationFrame(tick);
          return;
        }
        ctx.clearRect(0, 0, W, H);
        for (const p of pts) {
          p.ph += 0.009;
          p.y += p.dy;
          p.x += p.dx;
          if (p.y < -4) {
            p.y = H + 4;
            p.x = Math.random() * W;
          }
          ctx.beginPath();
          ctx.arc(p.x % W, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(198,168,74,${p.a * (0.6 + 0.4 * Math.sin(p.ph))})`;
          ctx.fill();
        }
        requestAnimationFrame(tick);
      })();
    }

    if (rail) {
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      const THRESHOLD = 6;

      rail.addEventListener('mousedown', (e) => {
        isDown = true;
        moved = false;
        startX = e.pageX - rail.offsetLeft;
        startScroll = rail.scrollLeft;
        rail.classList.add('is-dragging');
        rail.style.scrollBehavior = 'auto';
      });

      window.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const walk = e.pageX - rail.offsetLeft - startX;
        if (Math.abs(walk) > THRESHOLD) moved = true;
        rail.scrollLeft = startScroll - walk;
      });

      window.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        rail.classList.remove('is-dragging');
        rail.style.scrollBehavior = '';
      });

      rail.addEventListener(
        'click',
        (e) => {
          if (moved) {
            e.preventDefault();
            e.stopImmediatePropagation();
            moved = false;
          }
        },
        true
      );
    }

    const cw = () => (rail?.querySelector('.ece-card')?.offsetWidth ?? 234) + 10;
    document.getElementById('ece-prev-' + sid)?.addEventListener('click', () =>
      rail?.scrollBy({ left: -cw() * 2, behavior: 'smooth' })
    );
    document.getElementById('ece-next-' + sid)?.addEventListener('click', () =>
      rail?.scrollBy({ left: cw() * 2, behavior: 'smooth' })
    );

    if (dWrap && rail) {
      const dots = dWrap.querySelectorAll('.ece-dot');
      const cards = rail.querySelectorAll('.ece-card');

      const io = new IntersectionObserver(
        (entries) => {
          for (const en of entries) {
            if (!en.isIntersecting) continue;
            const i = Number(en.target.dataset.idx);
            dots.forEach((d, j) => d.classList.toggle('ece-dot--on', j === i));
          }
        },
        { root: rail, threshold: 0.55 }
      );

      cards.forEach((c) => io.observe(c));
      dots.forEach((d, i) =>
        d.addEventListener('click', () =>
          cards[i]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        )
      );
    }
  }

  function boot() {
    const queue = window.__luxuryCollectionQueue || [];
    window.__luxuryCollectionQueue = [];
    queue.forEach(initLuxuryCollection);
    document.querySelectorAll('.ece[id^="ece-"]').forEach((el) => {
      const id = el.id.replace(/^ece-/, '');
      if (id) initLuxuryCollection(id);
    });
  }

  window.initLuxuryCollection = initLuxuryCollection;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
